// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec8ae69f","400":"24baaa30","453":"a7bceb7a","455":"8fcd009d"}[chunkId] + ".chunk.js";
};